<template>
    <div class="form">
        <h4 class="step-title">
            Do you own or rent your home?
        </h4>
        <div class="step-content d-flex flex-column flex-md-row">
            <button-list v-bind:items="ownRent" v-bind:onclick="complete"></button-list>
        </div>
    </div>
</template>

<script>
    import ButtonList from "./shared/ButtonList.vue"

    export default {
        name: "CurrentResidenceType",
        components: {
            ButtonList
        },
        data: function() {
            return {
                ownRent: [
                    { text: "Own", value: "Own" },
                    { text: "Rent", value: "Rent" }
                ]
            }
        },
        props: {
            lead: Object
        },
        methods: {
          complete: function(currentResidenceType) {
              this.lead.currentResidenceType = currentResidenceType;
              this.$emit("complete", this.$options.name, currentResidenceType);
          }
        }
    }
</script>
